<template>
  <svg width="40" height="40" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="44" height="44" rx="22" fill="#14B8A6" />
    <path
      d="M12.999 27.2512V31.0012H16.749L27.809 19.9412L24.059 16.1912L12.999 27.2512ZM30.709 17.0412C31.099 16.6512 31.099 16.0212 30.709 15.6312L28.369 13.2912C27.979 12.9012 27.349 12.9012 26.959 13.2912L25.129 15.1212L28.879 18.8712L30.709 17.0412Z"
      fill="white"
    />
  </svg>
</template>

<script setup lang="ts"></script>
